import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import packageJson from '../../package.json';

const BASE_URL = packageJson.apiUrl;
const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // Parse query parameters from URL
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const token = queryParams.get("token");

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");
    setLoading(true);

    // Validate passwords
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            token,
            password: newPassword,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to reset password.");
      }

      const data = await response.json();
      setSuccess("Password reset successful!");

      // Optionally, navigate to the login page after success
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <BreadCrumb />

      <section className="login-page section-space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row g-0 justify-content-center">
                <div className="col-lg-6">
                  <div className="login-box">
                    <div className="login-left">
                      <h2 className="login-title">Reset Password</h2>

                      {error && <p style={{ color: "red" }}>{error}</p>}
                      {success && <p style={{ color: "green" }}>{success}</p>}

                      <form onSubmit={handlePasswordReset}>
                        <div className="form-group">
                          <label className="label-top">New Password</label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="Enter New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label className="label-top">Confirm Password</label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group text-center">
                          <button
                            type="submit"
                            className="btn btn-green"
                            disabled={loading}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
